<template>
  <div>
    <TabView v-model="activeTab">
      <TabPanel>
        <template #header>
          <h4>Check RCU</h4>
        </template>
        <div class="search-panel">
          <div class="search-row flex justify-content-center align-items-center mb-3">
            
          </div>
          <div class="search-row flex justify-content-center align-items-center mb-3">
            <div class="col-3">
              <Calendar v-model="selectedDateRcu" dateFormat="mm-yy" view="month" class="inputfield w-full" showIcon
                :manualInput="false" />
            </div>
            <div class="col-3">
              <Calendar v-model="startDate" dateFormat="dd-mm-yy" showIcon placeholder="Data Inizio"
                class="inputfield w-full" />
            </div>
            <div class="col-3">
              <Calendar v-model="endDate" dateFormat="dd-mm-yy" showIcon placeholder="Data Fine"
                class="inputfield w-full" />
            </div>
            <div class="col-3 flex justify-content-end">
              <Button label="Cerca" @click="getListCheckRcu" icon="pi pi-search" iconPos="left" class="button-small" />
            </div>
          </div>
        </div>
        <div class="separator" style="height: 1px; width: 100%; background-color: #ccc; margin: 10px 0;"></div>
        <Loader v-if="dataLoadingRcu" />
        <div v-if="searchExecutedRcu && filteredFilesRcu.length > 0">
          <div class="flex justify-content-between align-items-center mb-4" style="margin: 0 15px;">
            <strong>Totale record trovati: {{ filteredFilesRcu.length }}</strong>
            <Button label="Esporta File" icon="pi pi-external-link" class="p-button-secondary"
              @click="exportToExcelRcu" />
          </div>

          <DataTable
            :value="filteredFilesRcu"
            :filters="filters"
            :globalFilterFields="['code', 'indirizzo', 'indirizzoCliente', 'nomeCliente', 'agente_name', 'offerta_name', 'rappresentante_name']"
            filterDisplay="menu"
            :rows="10"
            :paginator="true"
            responsiveLayout="scroll"
          >
            <template #header>
              <div class="flex justify-content-between">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText v-model="filters['global'].value" placeholder="Cerca in tabella..." />
                </span>
              </div>
            </template>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Code</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.code">
                  <a @click="handleButtonClick3(slotProps.data.podid)" href="javascript:void(0)">
                    {{ slotProps.data.code }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.potenza_impegnata,
                    'p-button-text': !filterCriteriaRcu.potenza_impegnata,
                  }" @click="toggleEmptyFilter('potenza_impegnata', 'rcu')" class="p-button-rounded" />
                  Potenza Impegnata
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.potenza_impegnata">
                  {{ slotProps.data.potenza_impegnata }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.potenza_disponibile,
                    'p-button-text': !filterCriteriaRcu.potenza_disponibile,
                  }" @click="toggleEmptyFilter('potenza_disponibile', 'rcu')" class="p-button-rounded" />
                  Potenza Disponibile
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.potenza_disponibile">
                  {{ slotProps.data.potenza_disponibile }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.consumo_annuo,
                    'p-button-text': !filterCriteriaRcu.consumo_annuo,
                  }" @click="toggleEmptyFilter('consumo_annuo', 'rcu')" class="p-button-rounded" />
                  Consumo Annuo
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.consumo_annuo">
                  {{ slotProps.data.consumo_annuo }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.cluster,
                    'p-button-text': !filterCriteriaRcu.cluster,
                  }" @click="toggleEmptyFilter('cluster', 'rcu')" class="p-button-rounded" />
                  Cluster
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.cluster">
                  {{ slotProps.data.cluster }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.voltaggio,
                    'p-button-text': !filterCriteriaRcu.voltaggio,
                  }" @click="toggleEmptyFilter('voltaggio', 'rcu')" class="p-button-rounded" />
                  Voltaggio
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.voltaggio">
                  {{ slotProps.data.voltaggio }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.nomeTensione,
                    'p-button-text': !filterCriteriaRcu.nomeTensione,
                  }" @click="toggleEmptyFilter('nomeTensione', 'rcu')" class="p-button-rounded" />
                  Tensione
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.nomeTensione">
                  {{ slotProps.data.nomeTensione }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.indirizzo,
                    'p-button-text': !filterCriteriaRcu.indirizzo,
                  }" @click="toggleEmptyFilter('indirizzo', 'rcu')" class="p-button-rounded" />
                  Indirizzo POD
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.indirizzo">
                  {{ slotProps.data.indirizzo }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 150px" field="data_inizio" sortable>
              <template #header>
                <div class="header-with-button">Data Inizio</div>
              </template>
              <template #body="slotProps">
                <span class="no-wrap" v-if="slotProps.data.data_inizio">
                  {{ slotProps.data.data_inizio }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>

            <Column style="width: 150px" field="data_fine" sortable>
              <template #header>
                <div class="header-with-button">Data Fine</div>
              </template>
              <template #body="slotProps">
                <span class="no-wrap" v-if="slotProps.data.data_fine">
                  {{ slotProps.data.data_fine }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column>
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.indirizzoCliente,
                    'p-button-text': !filterCriteriaRcu.indirizzoCliente,
                  }" @click="toggleEmptyFilter('indirizzoCliente', 'rcu')" class="p-button-rounded" />
                  Indirizzo Cliente
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.indirizzoCliente">
                  {{ slotProps.data.indirizzoCliente }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filteredCliente,
                    'p-button-text': !filteredCliente,
                  }" @click="
                    toggleEmptyFilter('ragionesociale_o_nomeCliente', 'rcu')
                    " class="p-button-rounded" />
                  Nome Cliente
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="
                  slotProps.data.nomeCliente &&
                  slotProps.data.nomeCliente.trim() !== ''
                ">
                  <a @click="handleButtonClick4(slotProps.data.cliente_id)" href="javascript:void(0)">
                    {{ slotProps.data.nomeCliente }}
                  </a>
                </span>
                <span v-else-if="
                  slotProps.data.ragionesociale &&
                  slotProps.data.ragionesociale.trim() !== ''
                ">
                  <a @click="handleButtonClick4(slotProps.data.cliente_id)" href="javascript:void(0)">
                    {{ slotProps.data.ragionesociale }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.rappresentante_name,
                    'p-button-text': !filterCriteriaRcu.rappresentante_name,
                  }" @click="toggleEmptyFilter('rappresentante_name', 'rcu')" class="p-button-rounded" />
                  Nome Rappresentante
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.rappresentante_name">
                  <a @click="handleButtonClick(slotProps.data.rappid)" href="javascript:void(0)">
                    {{ slotProps.data.rappresentante_name }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.agente_name,
                    'p-button-text': !filterCriteriaRcu.agente_name,
                  }" @click="toggleEmptyFilter('agente_name', 'rcu')" class="p-button-rounded" />
                  Nome Agente
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.agente_name">
                  <a @click="handleButtonClick2(slotProps.data.agentid)" href="javascript:void(0)">
                    {{ slotProps.data.agente_name }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.agente_firmatario,
                    'p-button-text': !filterCriteriaRcu.agente_firmatario,
                  }" @click="toggleEmptyFilter('agente_firmatario', 'rcu')" class="p-button-rounded" />
                  Nome Agente Firmatario
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.agente_firmatario">
                  {{ slotProps.data.agente_firmatario }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.fornitore_cc,
                    'p-button-text': !filterCriteriaRcu.fornitore_cc,
                  }" @click="toggleEmptyFilter('fornitore_cc', 'rcu')" class="p-button-rounded" />
                  CC
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.fornitore_cc">
                  {{ slotProps.data.fornitore_cc }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.fornitore_udd,
                    'p-button-text': !filterCriteriaRcu.fornitore_udd,
                  }" @click="toggleEmptyFilter('fornitore_udd', 'rcu')" class="p-button-rounded" />
                  UDD
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.fornitore_udd">
                  {{ slotProps.data.fornitore_udd }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.is_point,
                    'p-button-text': !filterCriteriaRcu.is_point,
                  }" @click="toggleEmptyFilter('is_point', 'rcu')" class="p-button-rounded" />
                  Point
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.is_point">
                  {{ slotProps.data.is_point }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.codeContratto,
                    'p-button-text': !filterCriteriaRcu.codeContratto,
                  }" @click="toggleEmptyFilter('codeContratto', 'rcu')" class="p-button-rounded" />
                  Codice Contratto
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.codeContratto">
                  {{ slotProps.data.codeContratto }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button
                    icon="pi pi-filter"
                    :class="{
                      'p-button-success':
                        filterCriteriaRcu.data_inizio_contratto,
                      'p-button-text': !filterCriteriaRcu.data_inizio_contratto,
                    }"
                    @click="toggleEmptyFilter('data_inizio_contratto', 'rcu')"
                    class="p-button-rounded"
                  />
                  Data Inizio Contratto
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.data_inizio_contratto">
                  {{ slotProps.data.data_inizio_contratto }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button
                    icon="pi pi-filter"
                    :class="{
                      'p-button-success':
                        filterCriteriaRcu.tipo_mandato_contratto,
                      'p-button-text':
                        !filterCriteriaRcu.tipo_mandato_contratto,
                    }"
                    @click="toggleEmptyFilter('tipo_mandato_contratto', 'rcu')"
                    class="p-button-rounded"
                  />
                  Banca Rid
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.tipo_mandato_contratto">
                  {{ slotProps.data.tipo_mandato_contratto }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.piva,
                    'p-button-text': !filterCriteriaRcu.piva,
                  }" @click="toggleEmptyFilter('piva', 'rcu')" class="p-button-rounded" />
                  Partita Iva
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.piva">
                  {{ slotProps.data.piva }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.codfis,
                    'p-button-text': !filterCriteriaRcu.codfis,
                  }" @click="toggleEmptyFilter('codfis', 'rcu')" class="p-button-rounded" />
                  Codice Fiscale
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.codfis">
                  {{ slotProps.data.codfis }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.tipoCliente,
                    'p-button-text': !filterCriteriaRcu.tipoCliente,
                  }" @click="toggleEmptyFilter('tipoCliente', 'rcu')" class="p-button-rounded" />
                  Tipo Cliente
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.tipoCliente">
                  {{ slotProps.data.tipoCliente }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.nomeResidente,
                    'p-button-text': !filterCriteriaRcu.nomeResidente,
                  }" @click="toggleEmptyFilter('nomeResidente', 'rcu')" class="p-button-rounded" />
                  Tipo Residente
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.nomeResidente">
                  {{ slotProps.data.nomeResidente }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.nomeUso,
                    'p-button-text': !filterCriteriaRcu.nomeUso,
                  }" @click="toggleEmptyFilter('nomeUso', 'rcu')" class="p-button-rounded" />
                  Tipo Uso
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.nomeUso">
                  {{ slotProps.data.nomeUso }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.email,
                    'p-button-text': !filterCriteriaRcu.email,
                  }" @click="toggleEmptyFilter('email', 'rcu')" class="p-button-rounded" />
                  Email
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.email">
                  {{ slotProps.data.email }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.nomeSpedizione,
                    'p-button-text': !filterCriteriaRcu.nomeSpedizione,
                  }" @click="toggleEmptyFilter('nomeSpedizione', 'rcu')" class="p-button-rounded" />
                  Spedizione
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.nomeSpedizione">
                  {{ slotProps.data.nomeSpedizione }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.nomeFatturazione,
                    'p-button-text': !filterCriteriaRcu.nomeFatturazione,
                  }" @click="toggleEmptyFilter('nomeFatturazione', 'rcu')" class="p-button-rounded" />
                  Tipo Fatturazione
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.nomeFatturazione">
                  {{ slotProps.data.nomeFatturazione }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.nomePeriodo,
                    'p-button-text': !filterCriteriaRcu.nomePeriodo,
                  }" @click="toggleEmptyFilter('nomePeriodo', 'rcu')" class="p-button-rounded" />
                  Periodo Fatturazione
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.nomePeriodo">
                  {{ slotProps.data.nomePeriodo }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.tipo_pagamento,
                    'p-button-text': !filterCriteriaRcu.tipo_pagamento,
                  }" @click="toggleEmptyFilter('tipo_pagamento', 'rcu')" class="p-button-rounded" />
                  Tipo Pagamento
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.tipo_pagamento">
                  {{ slotProps.data.tipo_pagamento }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 900px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.iban,
                    'p-button-text': !filterCriteriaRcu.iban,
                  }" @click="toggleEmptyFilter('iban', 'rcu')" class="p-button-rounded" />
                  Iban
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.iban">
                  {{ slotProps.data.iban }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.intestazione,
                    'p-button-text': !filterCriteriaRcu.intestazione,
                  }" @click="toggleEmptyFilter('intestazione', 'rcu')" class="p-button-rounded" />
                  Intestazione RID
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.intestazione">
                  {{ slotProps.data.intestazione }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.offerta_name,
                    'p-button-text': !filterCriteriaRcu.offerta_name,
                  }" @click="toggleEmptyFilter('offerta_name', 'rcu')" class="p-button-rounded" />
                  Nome Offerta
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.offerta_name">
                  {{ slotProps.data.offerta_name }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
          </DataTable>
        </div>

        <div v-else-if="searchExecutedRcu" class="text-center mb-2">
          Nessun dato trovato.
        </div>
      </TabPanel>
      <TabPanel>
        <template #header>
          <h4>Check RCU GAS</h4>
        </template>
        <div class="search-panel">
          
          <div class="search-row flex justify-content-center align-items-center mb-3">
            <div class="col-3">
              <Calendar 
                v-model="selectedDateRcuGas" 
                dateFormat="mm-yy" 
                view="month" 
                class="inputfield w-full mt-2"
                showIcon 
                :manualInput="false" 
              />
            </div>
            <div class="col-3">
              <Calendar v-model="startDateRcuGas" dateFormat="dd-mm-yy" showIcon placeholder="Data Inizio"
                class="inputfield w-full mt-2" />
            </div>
            <div class="col-3">
              <Calendar v-model="endDateRcuGas" dateFormat="dd-mm-yy" showIcon placeholder="Data Fine"
                class="inputfield w-full mt-2" />
            </div>

            <div class="col-3 flex justify-content-end">
              <Button label="Cerca" @click="getListCheckRcuGas" icon="pi pi-search" iconPos="left"
                class="button-small" />
            </div>
          </div>
        </div>
        <div class="separator" style="height: 1px; width: 100%; background-color: #ccc; margin: 10px 0;"></div>
        <Loader v-if="dataLoadingRcu" />
        <div v-if="searchExecutedRcu && filteredFilesRcuGas.length > 0">
          <div class="flex justify-content-between align-items-center mb-4" style="margin: 0 15px;">
            <strong>Totale record trovati: {{ filteredFilesRcuGas.length }}</strong>
            <Button label="Esporta File" icon="pi pi-external-link" class="p-button-secondary"
              @click="exportToExcelRcuGas" />
          </div>
          <DataTable
            :value="filteredFilesRcuGas"
            :filters="filtersGas"
            :globalFilterFields="['code', 'indirizzo', 'indirizzoCliente', 'nomeCliente', 'agente_name']"
            filterDisplay="menu"
            :rows="10"
            :paginator="true"
            responsiveLayout="scroll"
          >
            <template #header>
              <div class="flex justify-content-between">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText v-model="filtersGas['global'].value" placeholder="Cerca in tabella..." />
                </span>
              </div>
            </template>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Code</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.code">
                  <a @click="handleButtonClick3(slotProps.data.podid)" href="javascript:void(0)">
                    {{ slotProps.data.code }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.consumo_annuo,
                    'p-button-text': !filterCriteriaRcu.consumo_annuo,
                  }" @click="toggleEmptyFilter('consumo_annuo', 'rcu')" class="p-button-rounded" />
                  Consumo Annuo
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.consumo_annuo">
                  {{ slotProps.data.consumo_annuo }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.indirizzo,
                    'p-button-text': !filterCriteriaRcu.indirizzo,
                  }" @click="toggleEmptyFilter('indirizzo', 'rcu')" class="p-button-rounded" />
                  Indirizzo PDR
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.indirizzo">
                  {{ slotProps.data.indirizzo }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.comune,
                    'p-button-text': !filterCriteriaRcu.comune,
                  }" @click="toggleEmptyFilter('comune', 'rcu')" class="p-button-rounded" />
                  Comune PDR
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.comune">
                  {{ slotProps.data.comune }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.provincia,
                    'p-button-text': !filterCriteriaRcu.provincia,
                  }" @click="toggleEmptyFilter('provincia', 'rcu')" class="p-button-rounded" />
                  Provincia PDR
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.provincia">
                  {{ slotProps.data.provincia }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.regione,
                    'p-button-text': !filterCriteriaRcu.regione,
                  }" @click="toggleEmptyFilter('regione', 'rcu')" class="p-button-rounded" />
                  Regione PDR
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.regione">
                  {{ slotProps.data.regione }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 150px" field="data_inizio" sortable>
              <template #header>
                <div class="header-with-button">Data Inizio</div>
              </template>
              <template #body="slotProps">
                <span class="no-wrap" v-if="slotProps.data.data_inizio">
                  {{ slotProps.data.data_inizio }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>

            <Column style="width: 150px" field="data_fine" sortable>
              <template #header>
                <div class="header-with-button">Data Fine</div>
              </template>
              <template #body="slotProps">
                <span class="no-wrap" v-if="slotProps.data.data_fine">
                  {{ slotProps.data.data_fine }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.indirizzoCliente,
                    'p-button-text': !filterCriteriaRcu.indirizzoCliente,
                  }" @click="toggleEmptyFilter('indirizzoCliente', 'rcu')" class="p-button-rounded" />
                  Indirizzo Cliente
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.indirizzoCliente">
                  {{ slotProps.data.indirizzoCliente }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>

            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filteredCliente,
                    'p-button-text': !filteredCliente,
                  }" @click="
                    toggleEmptyFilter('ragionesociale_o_nomeCliente', 'rcu')
                    " class="p-button-rounded" />
                  Nome Cliente
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="
                  slotProps.data.nomeCliente &&
                  slotProps.data.nomeCliente.trim() !== ''
                ">
                  <a @click="handleButtonClick4(slotProps.data.cliente_id)" href="javascript:void(0)">
                    {{ slotProps.data.nomeCliente }}
                  </a>
                </span>
                <span v-else-if="
                  slotProps.data.ragionesociale &&
                  slotProps.data.ragionesociale.trim() !== ''
                ">
                  <a @click="handleButtonClick4(slotProps.data.cliente_id)" href="javascript:void(0)">
                    {{ slotProps.data.ragionesociale }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.rappresentante_name,
                    'p-button-text': !filterCriteriaRcu.rappresentante_name,
                  }" @click="toggleEmptyFilter('rappresentante_name', 'rcu')" class="p-button-rounded" />
                  Nome Rappresentante
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.rappresentante_name">
                  <a @click="handleButtonClick(slotProps.data.rappid)" href="javascript:void(0)">
                    {{ slotProps.data.rappresentante_name }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.agente_name,
                    'p-button-text': !filterCriteriaRcu.agente_name,
                  }" @click="toggleEmptyFilter('agente_name', 'rcu')" class="p-button-rounded" />
                  Nome Agente
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.agente_name">
                  <a @click="handleButtonClick2(slotProps.data.agentid)" href="javascript:void(0)">
                    {{ slotProps.data.agente_name }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.agente_firmatario,
                    'p-button-text': !filterCriteriaRcu.agente_firmatario,
                  }" @click="toggleEmptyFilter('agente_firmatario', 'rcu')" class="p-button-rounded" />
                  Nome Agente Firmatario
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.agente_firmatario">
                  <a @click="handleButtonClick2(slotProps.data.agentid)" href="javascript:void(0)">
                    {{ slotProps.data.agente_firmatario }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.fornitore_cc,
                    'p-button-text': !filterCriteriaRcu.fornitore_cc,
                  }" @click="toggleEmptyFilter('fornitore_cc', 'rcu')" class="p-button-rounded" />
                  CC
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.fornitore_cc">
                  {{ slotProps.data.fornitore_cc }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.fornitore_udd,
                    'p-button-text': !filterCriteriaRcu.fornitore_udd,
                  }" @click="toggleEmptyFilter('fornitore_udd', 'rcu')" class="p-button-rounded" />
                  UDD
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.fornitore_udd">
                  {{ slotProps.data.fornitore_udd }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.is_point,
                    'p-button-text': !filterCriteriaRcu.is_point,
                  }" @click="toggleEmptyFilter('is_point', 'rcu')" class="p-button-rounded" />
                 Point
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.is_point">
                  <a>
                    {{ slotProps.data.is_point }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.codeContratto,
                    'p-button-text': !filterCriteriaRcu.codeContratto,
                  }" @click="toggleEmptyFilter('codeContratto', 'rcu')" class="p-button-rounded" />
                  Codice Contratto
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.codeContratto">
                  {{ slotProps.data.codeContratto }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button
                    icon="pi pi-filter"
                    :class="{
                      'p-button-success':
                        filterCriteriaRcu.data_inizio_contratto,
                      'p-button-text': !filterCriteriaRcu.data_inizio_contratto,
                    }"
                    @click="toggleEmptyFilter('data_inizio_contratto', 'rcu')"
                    class="p-button-rounded"
                  />
                  Data Inizio Contratto
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.data_inizio_contratto">
                  {{ slotProps.data.data_inizio_contratto }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button
                    icon="pi pi-filter"
                    :class="{
                      'p-button-success':
                        filterCriteriaRcu.tipo_mandato_contratto,
                      'p-button-text':
                        !filterCriteriaRcu.tipo_mandato_contratto,
                    }"
                    @click="toggleEmptyFilter('tipo_mandato_contratto', 'rcu')"
                    class="p-button-rounded"
                  />
                  Banca Rid
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.tipo_mandato_contratto">
                  {{ slotProps.data.tipo_mandato_contratto }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.codfis,
                    'p-button-text': !filterCriteriaRcu.codfis,
                  }" @click="toggleEmptyFilter('codfis', 'rcu')" class="p-button-rounded" />
                  Codice Fiscale
                </div>
              </template>
              <template #body="slotProps">
                <span
                  v-if="
                    slotProps.data.codfis && slotProps.data.codfis.trim() !== ''
                  "
                >
                  {{ slotProps.data.codfis }}
                </span>
                <span
                  v-else-if="
                    slotProps.data.piva && slotProps.data.piva.trim() !== ''
                  "
                >
                  {{ slotProps.data.piva }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.tipoCliente,
                    'p-button-text': !filterCriteriaRcu.tipoCliente,
                  }" @click="toggleEmptyFilter('tipoCliente', 'rcu')" class="p-button-rounded" />
                  Tipo Cliente
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.tipoCliente">
                  {{ slotProps.data.tipoCliente }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.nomeUso,
                    'p-button-text': !filterCriteriaRcu.nomeUso,
                  }" @click="toggleEmptyFilter('nomeUso', 'rcu')" class="p-button-rounded" />
                  Tipo Uso
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.nomeUso">
                  {{ slotProps.data.nomeUso }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column>
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.remi,
                    'p-button-text': !filterCriteriaRcu.remi,
                  }" @click="toggleEmptyFilter('remi', 'remi')" class="p-button-rounded" />
                  Remi
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.remi">
                  {{ slotProps.data.remi }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.email,
                    'p-button-text': !filterCriteriaRcu.email,
                  }" @click="toggleEmptyFilter('email', 'rcu')" class="p-button-rounded" />
                  Email
                </div>
              </template>
              <template #body="slotProps">
                <span
                  v-if="
                    slotProps.data.email && slotProps.data.email.trim() !== ''
                  "
                >
                  {{ slotProps.data.email }}
                </span>
                <span
                  v-else-if="
                    slotProps.data.emailContatto &&
                    slotProps.data.emailContatto.trim() !== ''
                  "
                >
                  {{ slotProps.data.emailContatto }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column>
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.nomeSpedizione,
                    'p-button-text': !filterCriteriaRcu.nomeSpedizione,
                  }" @click="toggleEmptyFilter('nomeSpedizione', 'rcu')" class="p-button-rounded" />
                  Spedizione
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.nomeSpedizione">
                  {{ slotProps.data.nomeSpedizione }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.nomePay,
                    'p-button-text': !filterCriteriaRcu.nomePay,
                  }" @click="toggleEmptyFilter('nomePay', 'rcu')" class="p-button-rounded" />
                  Tipo Pagamento
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.nomePay">
                  {{ slotProps.data.nomePay }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.nomeFatturazione,
                    'p-button-text': !filterCriteriaRcu.nomeFatturazione,
                  }" @click="toggleEmptyFilter('nomeFatturazione', 'rcu')" class="p-button-rounded" />
                  Tipo Fatturazione
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.nomeFatturazione">
                  {{ slotProps.data.nomeFatturazione }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.nomePeriodo,
                    'p-button-text': !filterCriteriaRcu.nomePeriodo,
                  }" @click="toggleEmptyFilter('nomePeriodo', 'rcu')" class="p-button-rounded" />
                  Periodo Fatturazione
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.nomePeriodo">
                  {{ slotProps.data.nomePeriodo }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.tipo_pagamento,
                    'p-button-text': !filterCriteriaRcu.tipo_pagamento,
                  }" @click="toggleEmptyFilter('tipo_pagamento', 'rcu')" class="p-button-rounded" />
                  Tipo Pagamento
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.tipo_pagamento">
                  {{ slotProps.data.tipo_pagamento }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 900px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.iban,
                    'p-button-text': !filterCriteriaRcu.iban,
                  }" @click="toggleEmptyFilter('iban', 'rcu')" class="p-button-rounded" />
                  Iban
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.iban">
                  {{ slotProps.data.iban }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.intestazione,
                    'p-button-text': !filterCriteriaRcu.intestazione,
                  }" @click="toggleEmptyFilter('intestazione', 'rcu')" class="p-button-rounded" />
                  Intestazione RID
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.intestazione">
                  {{ slotProps.data.intestazione }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">
                  <Button icon="pi pi-filter" :class="{
                    'p-button-success': filterCriteriaRcu.offerta_name,
                    'p-button-text': !filterCriteriaRcu.offerta_name,
                  }" @click="toggleEmptyFilter('offerta_name', 'rcu')" class="p-button-rounded" />
                  Nome Offerta
                </div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.offerta_name">
                  {{ slotProps.data.offerta_name }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
          </DataTable>
        </div>
        <div v-else-if="searchExecutedRcu" class="text-center mb-2">
          Nessun dato trovato.
        </div>
      </TabPanel>
      <TabPanel>
        <template #header>
          <h4>SEDA</h4>
        </template>
        <div class="search-panel">
         
          <div class="search-row flex justify-content-center align-items-center mb-3">
            <div class="col-3">
              <Calendar v-model="selectedDateSeda" dateFormat="mm-yy" view="month" class="inputfield w-full" showIcon
                :manualInput="false" />
            </div>
            <div class="col-2">
              <Calendar v-model="startDateSeda" dateFormat="dd-mm-yy" showIcon placeholder="Data Inizio"
                class="inputfield w-full" />
            </div>
            <div class="col-2">
              <Calendar v-model="endDateSeda" dateFormat="dd-mm-yy" showIcon placeholder="Data Fine"
                class="inputfield w-full" />
            </div>
            <div class="col-3 flex justify-content-end">
              <Dropdown v-model="tipoRidFilter" :options="tipoRidOptions" optionLabel="label" optionValue="value"
                placeholder="Seleziona Tipo Rid" class="w-full" />
            </div>
            <div class="col-2 flex justify-content-end">
              <Button label="Cerca" @click="getListCheckSeda" icon="pi pi-search" iconPos="right"
                class="button-small" />
            </div>
          </div>
        </div>
        <div class="separator" style="height: 1px; width: 100%; background-color: #ccc; margin: 10px 0;"></div>
        <Loader v-if="dataLoadingSeda" />
        <div v-if="searchExecutedSeda && filteredFilesSeda.length > 0">
          <div class="mb-4 ml-2">
            <strong
              >Totale record trovati: {{ filteredFilesSeda.length }}</strong
            >
            <Button
              label="Esporta Excel"
              icon="pi pi-file-excel"
              class="p-button-success ml-4"
              @click="exportToExcel('seda')"
            />
          </div>

          <DataTable
            :value="filteredFilesSeda"
            :filters="filtersSeda"
            :globalFilterFields="['code', 'indirizzo', 'indirizzoCliente', 'nomeCliente', 'tipo_rid']"
            filterDisplay="menu"
            :rows="10"
            :paginator="true"
            responsiveLayout="scroll"
          >
            <template #header>
              <div class="flex justify-content-between">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText v-model="filtersSeda['global'].value" placeholder="Cerca in tabella..." />
                </span>
              </div>
            </template>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Code</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.code">
                  <a @click="handleButtonClick3(slotProps.data.podid)" href="javascript:void(0)">
                    {{ slotProps.data.code }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Indirizzo POD</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.indirizzo">
                  {{ slotProps.data.indirizzo }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Indirizzo Cliente</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.indirizzoCliente">
                  {{ slotProps.data.indirizzoCliente }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 300px">
              <template #header>
                <div class="header-with-button">Email</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.EmailCliente">
                  {{ slotProps.data.EmailCliente }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 400px">
              <template #header>
                <div class="header-with-button">Partita Iva</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.PivaCliente">
                  {{ slotProps.data.PivaCliente }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Codice Fiscale</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.CodfisCliente">
                  {{ slotProps.data.CodfisCliente }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 150px" field="data_inizio" sortable>
              <template #header>
                <div class="header-with-button">Data Inizio</div>
              </template>
              <template #body="slotProps">
                <span class="no-wrap" v-if="slotProps.data.data_inizio">
                  {{ slotProps.data.data_inizio }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>

            <Column style="width: 150px" field="data_fine" sortable>
              <template #header>
                <div class="header-with-button">Data Fine</div>
              </template>
              <template #body="slotProps">
                <span class="no-wrap" v-if="slotProps.data.data_fine">
                  {{ slotProps.data.data_fine }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Nome Cliente</div>
              </template>
              <template #body="slotProps">
                <span v-if="
                  slotProps.data.nomeCliente &&
                  slotProps.data.nomeCliente.trim() !== ''
                ">
                  <a @click="handleButtonClick4(slotProps.data.cliente_id)" href="javascript:void(0)">
                    {{ slotProps.data.nomeCliente }}
                  </a>
                </span>
                <span v-else-if="
                  slotProps.data.ragionesociale_o_nomeCliente &&
                  slotProps.data.ragionesociale_o_nomeCliente.trim() !== ''
                ">
                  <a @click="handleButtonClick4(slotProps.data.cliente_id)" href="javascript:void(0)">
                    {{ slotProps.data.ragionesociale_o_nomeCliente }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 150px">
              <template #header>
                <div class="header-with-button">Tipo Rid</div>
              </template>
              <template #body="slotProps">
                <span class="no-wrap" v-if="slotProps.data.tipo_rid">
                  {{ slotProps.data.tipo_rid }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 150px">
              <template #header>
                <div class="header-with-button">Stato Seda</div>
              </template>
              <template #body="slotProps">
                <span class="no-wrap" v-if="slotProps.data.SedaStato">
                  {{ slotProps.data.SedaStato }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Esporta</div>
              </template>
              <template #body="slotProps">
                <Button v-if="slotProps.data.exportSeda === 1" icon="pi pi-check" class="p-button-rounded p-button-info"
                  label="Riesporta" @click="exportRecord(slotProps.data)" />
                <Button v-else icon="pi pi-file" class="p-button-success p-button-rounded export-button"
                  @click="exportRecord(slotProps.data)" />
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Cambia Tipo Rid</div>
              </template>
              <template #body="slotProps">
                <Button icon="fas fa-sync" class="p-button-warning p-button-rounded switch-button"
                  @click="openTipoRidDialog(slotProps.data)" />
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header> Cambia Stato Seda </template>
              <template #body="slotProps">
                <Dropdown v-model="slotProps.data.stato_seda" :options="statusOptions" optionLabel="label"
                  optionValue="value" class="w-full" @change="() => updateSedaStatus(slotProps.data)" />
              </template>
            </Column>
          </DataTable>
        </div>
        <div v-else-if="searchExecutedSeda" class="text-center mb-2">
          Nessun dato trovato.
        </div>
      </TabPanel>
      <TabPanel>
        <template #header>
          <h4>SEDA GAS</h4>
        </template>
        <div class="search-panel">
          
          <div class="search-row flex justify-content-center align-items-center mb-3">
            <div class="col-3">
              <Calendar v-model="selectedDateSeda" dateFormat="mm-yy" view="month" class="inputfield w-full" showIcon
                :manualInput="false" />
            </div>
            <div class="col-2">
              <Calendar v-model="startDateSedaGas" dateFormat="dd-mm-yy" showIcon placeholder="Data Inizio"
                class="inputfield w-fulL" />
            </div>
            <div class="col-2">
              <Calendar v-model="endDateSedaGas" dateFormat="dd-mm-yy" showIcon placeholder="Data Fine"
                class="inputfield w-full mt-2" />
            </div>
            <div class="col-3 flex justify-content-end">
              <Dropdown v-model="tipoRidFilter" :options="tipoRidOptions" optionLabel="label" optionValue="value"
                placeholder="Seleziona Tipo Rid" class="w-full" />
            </div>
            <div class="col-2 flex justify-content-end">
              <Button label="Cerca" @click="getListCheckSedaGas" icon="pi pi-search" iconPos="right"
                class="button-small" />
            </div>
          </div>
        </div>
        <div class="separator" style="height: 1px; width: 100%; background-color: #ccc; margin: 10px 0;"></div>
        <Loader v-if="dataLoadingSeda" />
        <div v-if="searchExecutedSeda && filteredFilesSedaGas.length > 0">
          <div class="mb-4 ml-2">
            <strong
              >Totale record trovati: {{ filteredFilesSedaGas.length }}</strong
            >
            <Button
              label="Esporta Excel"
              icon="pi pi-file-excel"
              class="p-button-success ml-4"
              @click="exportToExcel('sedaGas')"
            />
          </div>

          <DataTable
            :value="filteredFilesSedaGas"
            :filters="filtersSedaGas"
            :globalFilterFields="['code', 'indirizzo', 'indirizzoCliente', 'nomeCliente', 'tipo_rid']"
            filterDisplay="menu"
            :rows="10"
            :paginator="true"
            responsiveLayout="scroll"
          >
            <template #header>
              <div class="flex justify-content-between">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText v-model="filtersSedaGas['global'].value" placeholder="Cerca in tabella..." />
                </span>
              </div>
            </template>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Code</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.code">
                  <a @click="handleButtonClick3(slotProps.data.podid)" href="javascript:void(0)">
                    {{ slotProps.data.code }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>

            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Indirizzo PDR</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.indirizzo">
                  {{ slotProps.data.indirizzo }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Indirizzo Cliente</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.indirizzoCliente">
                  {{ slotProps.data.indirizzoCliente }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 300px">
              <template #header>
                <div class="header-with-button">Email</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.EmailCliente">
                  {{ slotProps.data.EmailCliente }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 400px">
              <template #header>
                <div class="header-with-button">Partita Iva</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.PivaCliente">
                  {{ slotProps.data.PivaCliente }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Codice Fiscale</div>
              </template>
              <template #body="slotProps">
                <span v-if="slotProps.data.CodfisCliente">
                  {{ slotProps.data.CodfisCliente }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 400px" field="data_inizio" sortable>
              <template #header>
                <div class="header-with-button">Data Inizio</div>
              </template>
              <template #body="slotProps">
                <span class="no-wrap" v-if="slotProps.data.data_inizio">
                  {{ slotProps.data.data_inizio }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>

            <Column style="width: 150px" field="data_fine" sortable>
              <template #header>
                <div class="header-with-button">Data Fine</div>
              </template>
              <template #body="slotProps">
                <span class="no-wrap" v-if="slotProps.data.data_fine">
                  {{ slotProps.data.data_fine }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Nome Cliente</div>
              </template>
              <template #body="slotProps">
                <span v-if="
                  slotProps.data.nomeCliente &&
                  slotProps.data.nomeCliente.trim() !== ''
                ">
                  <a @click="handleButtonClick4(slotProps.data.cliente_id)" href="javascript:void(0)">
                    {{ slotProps.data.nomeCliente }}
                  </a>
                </span>
                <span v-else-if="
                  slotProps.data.ragionesociale_o_nomeCliente &&
                  slotProps.data.ragionesociale_o_nomeCliente.trim() !== ''
                ">
                  <a @click="handleButtonClick4(slotProps.data.cliente_id)" href="javascript:void(0)">
                    {{ slotProps.data.ragionesociale_o_nomeCliente }}
                  </a>
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 150px">
              <template #header>
                <div class="header-with-button">Tipo Rid</div>
              </template>
              <template #body="slotProps">
                <span class="no-wrap" v-if="slotProps.data.tipo_rid">
                  {{ slotProps.data.tipo_rid }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 150px">
              <template #header>
                <div class="header-with-button">Stato Seda</div>
              </template>
              <template #body="slotProps">
                <span class="no-wrap" v-if="slotProps.data.SedaStato">
                  {{ slotProps.data.SedaStato }}
                </span>
                <span v-else>
                  <i class="pi pi-exclamation-circle" style="color: red"></i>
                </span>
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Esporta</div>
              </template>
              <template #body="slotProps">
                <Button v-if="slotProps.data.exportSeda === 1" icon="pi pi-check" class="p-button-rounded p-button-info"
                  label="Riesporta" @click="exportRecord(slotProps.data)" />
                <Button v-else icon="pi pi-file" class="p-button-success p-button-rounded export-button"
                  @click="exportRecord(slotProps.data)" />
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header>
                <div class="header-with-button">Cambia Tipo Rid</div>
              </template>
              <template #body="slotProps">
                <Button icon="fas fa-sync" class="p-button-warning p-button-rounded switch-button"
                  @click="openTipoRidDialog(slotProps.data)" />
              </template>
            </Column>
            <Column style="width: 200px">
              <template #header> Cambia Stato Seda </template>
              <template #body="slotProps">
                <Dropdown v-model="slotProps.data.stato_seda" :options="statusOptions" optionLabel="label"
                  optionValue="value" class="w-full" @change="() => updateSedaStatus(slotProps.data)" />
              </template>
            </Column>
          </DataTable>
        </div>
        <div v-else-if="searchExecutedSeda" class="text-center mb-2">
          Nessun dato trovato.
        </div>
      </TabPanel>
    </TabView>

    <Dialog header="Cambia Tipo Rid" v-model:visible="tipoRidDialog" :footer="dialogFooter">
      <div v-for="record in relatedRecords" :key="record.cod_contratto" class="p-field-checkbox">
        <label>{{ record.code }} / {{ record.tipo_rid }}</label>
        <Dropdown v-model="record.selectedTipoRid" :options="tipoRidOptions" optionLabel="label" class="w-full"
          placeholder="Seleziona Tipo RID" />
      </div>
      <Button class="mt-3" label="OK" icon="pi pi-check" @click="changeTipoRid" />
    </Dialog>
  </div>
</template>

<script>
import { ref, getCurrentInstance, computed } from "vue";
import { useToast } from "primevue/usetoast";
import CheckRcuService from "@/services/ask-management/CheckRcu";
import Loader from "@/components/Loader.vue";
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import * as XLSX from "xlsx";
import { FilterMatchMode } from 'primevue/api';

export default {
  components: {
    Loader,
    DataTable,
    Column,
    Button,
    Calendar,
    TabView,
    TabPanel,
    Dialog,
    Dropdown,
  },
  setup() {
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;

    const toast = useToast();

    const dataRcu = ref({
      files: [],
    });
    const dataLoadingRcu = ref(false);
    const selectedDateRcu = ref(new Date());
    const codeFilterRcu = ref("");
    const startDate = ref(null);
    const endDate = ref(null);
    const searchExecutedRcu = ref(false);
    const filterCriteriaRcu = ref({
      code: false,
      indirizzo: false,
      indirizzoCliente: false,
      data_inizio: false,
      data_fine: false,
      ragionesociale_o_nomeCliente: false,
      agente_name: false,
      offerta_name: false,
      rappresentante_name: false,
    });

    const dataSeda = ref({
      files: [],
    });
    const dataLoadingSeda = ref(false);
    const selectedDateSeda = ref(new Date());
    const codeFilterSeda = ref("");
    const startDateSeda = ref(null);
    const endDateSeda = ref(null);
    const startDateRcuGas = ref(null);
    const endDateRcuGas = ref(null);
    const startDateSedaGas = ref(null);
    const endDateSedaGas = ref(null);
    const searchExecutedSeda = ref(false);
    const filterCriteriaSeda = ref({
      code: false,
      indirizzo: false,
      indirizzoCliente: false,
      data_inizio: false,
      data_fine: false,
      ragionesociale_o_nomeCliente: false,
    });
    const tipoRidFilter = ref("");
    const newEntryFilter = ref(false);

    const tipoRidDialog = ref(false);
    const selectedTipoRid = ref("");
    const selectedRecord = ref(null);
    const tipoRidOptions = ref([
      { label: "BPM - B2B", value: "BPM - B2B" },
      { label: "MPS - CORE", value: "MPS - CORE" },
      { label: "MPS - B2B", value: "MPS - B2B" },
      { label: "BPM - CORE", value: "BPM - CORE" },
    ]);

    const statusOptions = ref([
      { label: "ACCETTATO", value: "ACCETTATO" },
      { label: "RIFIUTATO", value: "RIFIUTATO" },
      { label: "SOSPESO", value: "SOSPESO" },
    ]);

    const service = new CheckRcuService(self.$eventBus);

    const getListCheckRcu = async () => {
      try {
        dataLoadingRcu.value = true;
        searchExecutedRcu.value = false;
        resetFilters("rcu");
        const formattedDate = formatDate(selectedDateRcu.value);
        const response = await service.getListCheckRcu(formattedDate);
        dataRcu.value.files = response;
        searchExecutedRcu.value = true;
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
      } finally {
        dataLoadingRcu.value = false;
      }
    };

    const getListCheckRcuGas = async () => {
      try {
        dataLoadingRcu.value = true;
        searchExecutedRcu.value = false;
        resetFilters("rcu");
        const formattedDate = formatDate(selectedDateRcuGas.value);
        const response = await service.getListCheckRcuGas(formattedDate);
        dataRcu.value.files = response;
        searchExecutedRcu.value = true;
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
      } finally {
        dataLoadingRcu.value = false;
      }
    };

    const getListCheckSeda = async () => {
      try {
        dataLoadingSeda.value = true;
        searchExecutedSeda.value = false;
        resetFilters("seda");
        const formattedDate = formatDate(selectedDateSeda.value);
        const response = await service.getListSeda(formattedDate);
        dataSeda.value.files = response;
        searchExecutedSeda.value = true;
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
      } finally {
        dataLoadingSeda.value = false;
      }
    };

    const getListCheckSedaGas = async () => {
      try {
        dataLoadingSeda.value = true;
        searchExecutedSeda.value = false;
        resetFilters("seda");
        const formattedDate = formatDate(selectedDateSeda.value);
        const response = await service.getListSedaGas(formattedDate);
        dataSeda.value.files = response;
        searchExecutedSeda.value = true;
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
      } finally {
        dataLoadingSeda.value = false;
      }
    };

    const resetFilters = (type) => {
      const criteria =
        type === "rcu" ? filterCriteriaRcu.value : filterCriteriaSeda.value;
      Object.keys(criteria).forEach((field) => {
        criteria[field] = false;
      });

      if (type === "seda") {
        tipoRidFilter.value = "";
        newEntryFilter.value = false;
      }
    };

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      return `${year}-${month}`;
    };

    const handleButtonClick = (rappidValue) => {
      window.open(`/ask/rappresentanti/${rappidValue}/dettagli`);
    };

    const handleButtonClick2 = (agentidValue) => {
      window.open(`/ask/agenti/${agentidValue}/dettagli`);
    };

    const handleButtonClick3 = (podidValue) => {
      window.open(`/ask/pods/${podidValue}/dettagli`);
    };

    const handleButtonClick4 = (clienteidValue) => {
      window.open(`/ask/clienti/${clienteidValue}/dettagli`);
    };

    const toggleEmptyFilter = (field, type) => {
      const criteria =
        type === "rcu" ? filterCriteriaRcu.value : filterCriteriaSeda.value;
      if (criteria[field]) {
        criteria[field] = false;
      } else {
        resetFilters(type);
        criteria[field] = true;
      }
    };

    const toggleTipoRidFilter = (tipoRid) => {
      if (tipoRidFilter.value === tipoRid) {
        tipoRidFilter.value = "";
      } else {
        tipoRidFilter.value = tipoRid;
      }
    };

    const toggleNewEntryFilter = () => {
      newEntryFilter.value = !newEntryFilter.value;
    };

    const openTipoRidDialog = async (record) => {
      try {
        selectedRecord.value = record;
        const response = await service.getListDialogChangeRid(
          record.contrattoIban
        );
        relatedRecords.value = response.map((record) => ({
          ...record,
          selectedTipoRid: record.tipo_rid,
        }));
        tipoRidDialog.value = true;
      } catch (error) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Non è stato possibile ottenere i record correlati",
        });
      }
    };

    const closeTipoRidDialog = () => {
      tipoRidDialog.value = false;
    };

    const changeTipoRid = async () => {
      try {
        const payloads = relatedRecords.value
          .filter((record) => record.selectedTipoRid)
          .map((record) => ({
            cod_contratto: record.cod_contratto,
            tipo_rid: record.selectedTipoRid.value,
          }));

        if (payloads.length > 0) {
          await service.changeTipoRid(payloads);

          relatedRecords.value.forEach((record) => {
            if (record.selectedTipoRid) {
              record.tipo_rid = record.selectedTipoRid.value;
            }
          });

          toast.add({
            severity: "success",
            summary: "Successo",
            detail: "Tipo RID cambiato con successo per i record selezionati",
          });
        } else {
          toast.add({
            severity: "warn",
            summary: "Attenzione",
            detail: "Nessun Tipo RID selezionato per il cambiamento",
          });
        }

        tipoRidDialog.value = false;
      } catch (error) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Non è stato possibile cambiare il Tipo RID",
        });
      }
    };

    const exportRecord = async (record) => {
      try {
        const contractId = record.cod_contratto;
        await service.exportRecord(contractId);
        toast.add({
          severity: "success",
          summary: "Successo",
          detail: "Record esportato con successo",
        });
      } catch (error) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Non è stato possibile esportare il record",
        });
      }
    };

    const updateSedaStatus = async (record) => {
      try {
        const payload = {
          contrattoId: record.cod_contratto,
          stato_seda: record.stato_seda,
        };
        await service.updateSedaStatus(payload);
        toast.add({
          severity: "success",
          summary: "Successo",
          detail: "Stato Seda aggiornato con successo",
        });
      } catch (error) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Non è stato possibile aggiornare lo stato",
        });
      }
    };


    const exportToExcelRcu = () => {
      const dataToExport = filteredFilesRcu.value.map(item => ({
        'Code': item.code || '',
        'Potenza Impegnata': item.potenza_impegnata || '',
        'Potenza Disponibile': item.potenza_disponibile || '',
        'Consumo Annuo': item.consumo_annuo || '',
        'Cluster': item.cluster || '',
        'Voltaggio': item.voltaggio || '',
        'Tensione': item.nomeTensione || '',
        'Indirizzo POD': item.indirizzo || '',
        'Data Inizio': item.data_inizio || '',
        'Data Fine': item.data_fine || '',
        'Indirizzo Cliente': item.indirizzoCliente || '',
       'Nome Cliente': (item.nomeCliente && item.nomeCliente.trim() !== '') ? item.nomeCliente : 
                   (item.ragionesociale_o_nomeCliente && item.ragionesociale_o_nomeCliente.trim() !== '') ? 
                   item.ragionesociale_o_nomeCliente : 'N/D',
        'Nome Rappresentante': item.rappresentante_name || '',
        'Nome Agente': item.agente_name || '',
        'Nome Agente Firmatario': item.agente_firmatario || '',
        'CC': item.fornitore_cc || '',
        'UDD': item.fornitore_udd || '',
        'Point': item.is_point || '',
        'Codice Contratto': item.codeContratto || '',
        'Data Inizio Contratto': item.data_inizio_contratto || '',
        'Banca Rid': item.tipo_mandato_contratto || '',
        'Partita Iva': item.piva || '',
        'Codice Fiscale': item.codfis || '',
        'Tipo Cliente': item.tipoCliente || '',
        'Tipo Residente': item.nomeResidente || '',
        'Tipo Uso': item.nomeUso || '',
        'Email': item.email || '',
        'Spedizione': item.nomeSpedizione || '',
        'Tipo Fatturazione': item.nomeFatturazione || '',
        'Periodo Fatturazione': item.nomePeriodo || '',
        'Tipo Pagamento': item.tipo_pagamento || '',
        'Iban': item.iban || '',
        'Intestazione RID': item.intestazione || '',
        'Nome Offerta': item.offerta_name || ''
      }));

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'RCU Data');
      XLSX.writeFile(wb, 'rcu_export.xlsx');
    };



    
    const exportToExcelRcuGas = () => {
      const dataToExport = filteredFilesRcuGas.value.map(item => ({
        'Code': item.code || '',
        'Consumo Annuo': item.consumo_annuo || '',
        'Indirizzo PDR': item.indirizzo || '',
        'Comune PDR': item.comune || '',
        'Provincia PDR': item.provincia || '',
        'Regione PDR': item.regione || '',
        'Data Inizio': item.data_inizio || '',
        'Data Fine': item.data_fine || '',
        'Indirizzo Cliente': item.indirizzoCliente || '',
        'Nome Cliente': (item.nomeCliente && item.nomeCliente.trim() !== '') ? item.nomeCliente : 
                   (item.ragionesociale_o_nomeCliente && item.ragionesociale_o_nomeCliente.trim() !== '') ? 
                   item.ragionesociale_o_nomeCliente : 'N/D',
        'Nome Rappresentante': item.rappresentante_name || '',
        'Nome Agente': item.agente_name || '',
        'Nome Agente Firmatario': item.agente_firmatario || '',
        'CC': item.fornitore_cc || '',
        'UDD': item.fornitore_udd || '',
        'Point': item.is_point || '',
        'Codice Contratto': item.codeContratto || '',
        'Data Inizio Contratto': item.data_inizio_contratto || '',
        'Banca Rid': item.tipo_mandato_contratto || '',
        'Codice Fiscale': item.codfis || '',
        'Tipo Cliente': item.tipoCliente || '',
        'Tipo Uso': item.nomeUso || '',
        'Email': item.email || '',
        'Spedizione': item.nomeSpedizione || '',
        'Tipo Fatturazione': item.nomeFatturazione || '',
        'Periodo Fatturazione': item.nomePeriodo || '',
        'Tipo Pagamento': item.tipo_pagamento || '',
        'Iban': item.iban || '',
        'Intestazione RID': item.intestazione || '',
        'Nome Offerta': item.offerta_name || ''
      }));

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'RCU Gas Data');
      XLSX.writeFile(wb, 'rcu_gas_export.xlsx');
    };

    const exportToExcel = (tab) => {
      let exportData = [];

      if (tab === "seda") {
        exportData = dataSeda.value.files.map((file) => ({
          Code: file.code || "",
          Indirizzo: file.indirizzo || "",
          IndirizzoCliente: file.indirizzoCliente || "",
          Email: file.EmailCliente || "",
          PartitaIva: file.PivaCliente || "",
          CodiceFiscale: file.CodfisCliente || "",
          DataInizio: file.data_inizio || "",
          DataFine: file.data_fine || "",
          NomeCliente:
            file.nomeCliente || file.ragionesociale_o_nomeCliente || "",
          TipoRid: file.tipo_rid || "",
        }));
      } else if (tab === "sedaGas") {
        exportData = dataSeda.value.files.map((file) => ({
          Code: file.code || "",
          IndirizzoPOD: file.indirizzo || "",
          IndirizzoCliente: file.indirizzoCliente || "",
          Email: file.EmailCliente || "",
          PartitaIva: file.PivaCliente || "",
          CodiceFiscale: file.CodfisCliente || "",
          DataInizio: file.data_inizio || "",
          DataFine: file.data_fine || "",
          NomeCliente:
            file.nomeCliente || file.ragionesociale_o_nomeCliente || "",
          TipoRid: file.tipo_rid || "",
        }));
      }
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        tab === "seda" ? "SEDA" : "SEDA Gas"
      );

      XLSX.writeFile(
        workbook,
        `${tab === "seda" ? "SEDA" : "SEDA_Gas"}_export.xlsx`
      );
    };

    const filteredFilesRcu = computed(() => {
      let result = dataRcu.value.files;
      if (codeFilterRcu.value) {
        const filterValue = codeFilterRcu.value.toLowerCase();
        result = result.filter(
          (file) =>
            (file.code && file.code.toLowerCase().includes(filterValue)) ||
            (file.indirizzo &&
              file.indirizzo.toLowerCase().includes(filterValue)) ||
            (file.indirizzoCliente &&
              file.indirizzoCliente.toLowerCase().includes(filterValue)) ||
            (file.ragionesociale_o_nomeCliente &&
              file.ragionesociale_o_nomeCliente
                .toLowerCase()
                .includes(filterValue)) ||
            (file.agente_name &&
              file.agente_name.toLowerCase().includes(filterValue)) ||
            (file.offerta_name &&
              file.offerta_name.toLowerCase().includes(filterValue)) ||
            (file.rappresentante_name &&
              file.rappresentante_name.toLowerCase().includes(filterValue))
        );
      }

      if (startDate.value && endDate.value) {
        result = result.filter((file) => {
          const fileDate = new Date(file.data_inizio);
          return fileDate >= startDate.value && fileDate <= endDate.value;
        });
      }

      Object.keys(filterCriteriaRcu.value).forEach((field) => {
        if (filterCriteriaRcu.value[field]) {
          result = result.filter((file) => !file[field]);
        }
      });

      return result;
    });

    const filteredFilesSeda = computed(() => {
      let result = dataSeda.value.files;

      if (codeFilterSeda.value) {
        const filterValue = codeFilterSeda.value.toLowerCase();
        result = result.filter(
          (file) =>
            (file.code && file.code.toLowerCase().includes(filterValue)) ||
            (file.CodfisCliente &&
              file.CodfisCliente.toLowerCase().includes(filterValue)) ||
            (file.PivaCliente &&
              file.PivaCliente.toLowerCase().includes(filterValue)) ||
            (file.indirizzo &&
              file.indirizzo.toLowerCase().includes(filterValue)) ||
            (file.indirizzoCliente &&
              file.indirizzoCliente.toLowerCase().includes(filterValue)) ||
            (file.ragionesociale_o_nomeCliente &&
              file.ragionesociale_o_nomeCliente
                .toLowerCase()
                .includes(filterValue))
        );
      }

      Object.keys(filterCriteriaSeda.value).forEach((field) => {
        if (filterCriteriaSeda.value[field]) {
          result = result.filter((file) => !file[field]);
        }
      });

      if (tipoRidFilter.value) {
        result = result.filter((file) => file.tipo_rid === tipoRidFilter.value);
      }

      if (newEntryFilter.value) {
        const currentMonth = formatDate(new Date());
        result = result.filter(
          (file) =>
            formatDate(new Date(file.data_inizio)) === currentMonth &&
            file.ridIban === 0
        );
      }

      if (startDateSeda.value && endDateSeda.value) {
        result = result.filter((file) => {
          const fileDate = new Date(file.data_inizio);
          return (
            fileDate >= startDateSeda.value && fileDate <= endDateSeda.value
          );
        });
      }

      return result;
    });

    const filteredFilesRcuGas = computed(() => {
      let result = dataRcu.value.files;
      if (codeFilterRcu.value) {
        const filterValue = codeFilterRcu.value.toLowerCase();
        result = result.filter(
          (file) =>
            (file.code && file.code.toLowerCase().includes(filterValue)) ||
            (file.indirizzo &&
              file.indirizzo.toLowerCase().includes(filterValue)) ||
            (file.indirizzoCliente &&
              file.indirizzoCliente.toLowerCase().includes(filterValue)) ||
            (file.ragionesociale_o_nomeCliente &&
              file.ragionesociale_o_nomeCliente
                .toLowerCase()
                .includes(filterValue)) ||
            (file.agente_name &&
              file.agente_name.toLowerCase().includes(filterValue)) ||
            (file.offerta_name &&
              file.offerta_name.toLowerCase().includes(filterValue)) ||
            (file.rappresentante_name &&
              file.rappresentante_name.toLowerCase().includes(filterValue))
        );
      }

      if (startDateRcuGas.value && endDateRcuGas.value) {
        result = result.filter((file) => {
          const fileDate = new Date(file.data_inizio);
          return (
            fileDate >= startDateRcuGas.value && fileDate <= endDateRcuGas.value
          );
        });
      }

      Object.keys(filterCriteriaRcu.value).forEach((field) => {
        if (filterCriteriaRcu.value[field]) {
          result = result.filter((file) => !file[field]);
        }
      });

      return result;
    });

    const filteredFilesSedaGas = computed(() => {
      let result = dataSeda.value.files;

      if (codeFilterSeda.value) {
        const filterValue = codeFilterSeda.value.toLowerCase();
        result = result.filter(
          (file) =>
            (file.code && file.code.toLowerCase().includes(filterValue)) ||
            (file.CodfisCliente &&
              file.CodfisCliente.toLowerCase().includes(filterValue)) ||
            (file.PivaCliente &&
              file.PivaCliente.toLowerCase().includes(filterValue)) ||
            (file.indirizzo &&
              file.indirizzo.toLowerCase().includes(filterValue)) ||
            (file.indirizzoCliente &&
              file.indirizzoCliente.toLowerCase().includes(filterValue)) ||
            (file.ragionesociale_o_nomeCliente &&
              file.ragionesociale_o_nomeCliente
                .toLowerCase()
                .includes(filterValue))
        );
      }

      Object.keys(filterCriteriaSeda.value).forEach((field) => {
        if (filterCriteriaSeda.value[field]) {
          result = result.filter((file) => !file[field]);
        }
      });

      if (tipoRidFilter.value) {
        result = result.filter((file) => file.tipo_rid === tipoRidFilter.value);
      }

      if (newEntryFilter.value) {
        const currentMonth = formatDate(new Date());
        result = result.filter(
          (file) =>
            formatDate(new Date(file.data_inizio)) === currentMonth &&
            file.ridIban === 0
        );
      }

      if (startDateSedaGas.value && endDateSedaGas.value) {
        result = result.filter((file) => {
          const fileDate = new Date(file.data_inizio);
          return (
            fileDate >= startDateSedaGas.value &&
            fileDate <= endDateSedaGas.value
          );
        });
      }

      return result;
    });

    const relatedRecords = ref([]);

    const filteredCliente = computed(() => {
      return (
        filterCriteriaRcu.value.ragionesociale_o_nomeCliente ||
        filterCriteriaRcu.value.nomeCliente
      );
    });

    // Inizializza i filtri usando FilterMatchMode
    const filters = ref({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    
    const filtersGas = ref({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    
    const filtersSeda = ref({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    
    const filtersSedaGas = ref({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    const selectedDateRcuGas = ref(new Date());

    return {
      dataRcu,
      dataLoadingRcu,
      selectedDateRcu,
      codeFilterRcu,
      startDate,
      endDate,
      searchExecutedRcu,
      filterCriteriaRcu,
      getListCheckRcu,
      getListCheckRcuGas,
      filteredFilesRcu,
      filteredFilesRcuGas,

      dataSeda,
      dataLoadingSeda,
      selectedDateSeda,
      codeFilterSeda,
      searchExecutedSeda,
      startDateSeda,
      endDateSeda,
      startDateRcuGas,
      endDateRcuGas,
      startDateSedaGas,
      endDateSedaGas,
      filterCriteriaSeda,
      getListCheckSeda,
      getListCheckSedaGas,
      filteredFilesSeda,
      filteredFilesSedaGas,
      handleButtonClick,
      handleButtonClick2,
      handleButtonClick3,
      handleButtonClick4,
      toggleEmptyFilter,
      exportRecord,
      toggleTipoRidFilter,
      toggleNewEntryFilter,
      tipoRidFilter,
      newEntryFilter,
      tipoRidDialog,
      selectedTipoRid,
      tipoRidOptions,
      statusOptions,
      openTipoRidDialog,
      closeTipoRidDialog,
      changeTipoRid,
      updateSedaStatus,
      toast,
      relatedRecords,
      filteredCliente,
      exportToExcel,
      exportToExcelRcu,
      exportToExcelRcuGas,
      filters,
      filtersGas,
      filtersSeda,
      filtersSedaGas,
      selectedDateRcuGas,
    };
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  flex-wrap: nowrap;
}

.align-items-center {
  align-items: center;
}

.justify-content-start {
  justify-content: flex-start;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.search-panel {
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.search-row {
  display: flex;
  justify-content: center;
}

.filters-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.inputfield,
.input-filter {
  width: 100%;
}

.filters-row {
  justify-content: flex-end;
}

.date-range-filter {
  display: flex;
  gap: 20px;
  align-items: center;
  width: 100%;
}

.search-button {
  width: auto;
  padding: 0.5rem 1rem;
}

.input-filter {
  width: 50%;
  max-width: 300px;
}

.column-data {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.divider {
  height: 1px;
  width: 100%;
  background-color: black;
  margin: 5px 0;
}

.inferior-value {
  color: red;
}

.success-alert {
  background-color: #d4edda;
  color: #155724;
  padding: 10px;
  margin: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  border-radius: 5px;
}

.p-button-success {
  background-color: #2196f3 !important;
  color: #fff !important;
}

.header-with-button {
  display: flex;
  align-items: center;
  gap: 5px;
}

.p-button-rounded.p-button-success,
.p-button-rounded.p-button-text {
  border-color: transparent !important;
}

.no-wrap {
  white-space: nowrap;
}

.export-button .pi-file-export {
  color: #fff !important;
}

.p-button-success .pi-file-export {
  color: #fff !important;
}

.filter-buttons {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.date-range-filter {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.p-field-checkbox {
  margin-bottom: 10px;
}

.separator {
  flex-grow: 1;
  margin: 0 10px;
  height: 1px;
  background-color: #ccc;
  /* Puoi personalizzare il colore */
}
</style>
